import React, {Proptype, Component} from 'react'
import {browserHistory, Link} from 'react-router'
import {connect} from 'react-redux'
import { alert } from 'util/alert';
import locale from './locale'
import './NoPermission.scss'
import {PanelWrapper} from 'components/UI'

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = (dispatch) => {
	return {
	};
};

class NoPermission extends Component {
  constructor(props){
    super(props)

    this.state = {

    }
  }


  render(){
    return(
      <PanelWrapper className='no-permission-container'>
        <span>:(</span>
        <h1>{__('Oops!', locale)}</h1>
        <h3>{__('You do not have the permission to visit this page, please contact the school principal for permission', locale)}</h3>

      </PanelWrapper>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoPermission)



// WEBPACK FOOTER //
// ./src/containers/pages/NoPermission/index.js